/**
 * Organization route group - requires authentication.
 *
 * This is the parent layout for all /org/:orgSlug/* routes.
 * It handles authentication but NOT organization context.
 * Organization context is handled in org.$orgSlug.tsx.
 */

import { identifyPostHogUser, setDatadogUser } from "@/lib/analytics-loader";
import { getCachedSession, sessionQueryOptions } from "@/lib/queries/session";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(org)")({
  beforeLoad: async ({ context, location }) => {
    let session = getCachedSession(context.queryClient);

    if (session === undefined) {
      session = await context.queryClient.fetchQuery(sessionQueryOptions());
    }

    if (!session?.user || !session?.session) {
      throw redirect({
        to: "/login",
        search: { returnTo: location.href },
      });
    }

    // Set user in analytics for session attribution (fire-and-forget, don't block navigation)
    void Promise.all([
      setDatadogUser(session.user),
      identifyPostHogUser(session.user),
    ]);

    return { user: session.user, session };
  },
  component: OrgRouteLayout,
});

function OrgRouteLayout() {
  return <Outlet />;
}
